const ArrayUtils = {}

/**
 * 
 * @param {Object} arr Biến cần kiểm tra xem có phải là mảng hai chiều không
 * @returns Biến truyền vào có phải là mảng hai chiều không?
 */
ArrayUtils.is2DArray = (arr) => {
  // Kiểm tra mảng 1 chiều
  if (!Array.isArray(arr)) {
    return false
  }

  // Nếu mảng rỗng => không phải mảng 2 chièu
  if (arr.length === 0) {
    return false
  }

  // Kiểm tra phần từ đầu tiên có phải mảng hay không
  return Array.isArray(arr[0])
}

/**
 * Hàm để lấy X phần tử trước và sau các phần tử thỏa mãn một điều kiện filter
 * 
 * filterFunc là hàm để lọc các phần tử
 * Vd: const filterFunction = obj => obj.id > 10;
 * 
 */
ArrayUtils.getNeighbours = (list, filterFunc, bound = 15) => {
  const index = list.findIndex(filterFunc);
  if (index === -1) {
    return []; // Nếu không tìm thấy phần tử thỏa mãn filter
  }
  const startIndex = Math.max(0, index - bound); // Lấy 15 phần tử trước (hoặc ít hơn nếu không đủ)
  const endIndex = Math.min(list.length - 1, index + bound); // Lấy 15 phần tử sau (hoặc ít hơn nếu không đủ)
  return list.slice(startIndex, endIndex + 1);
}

export default ArrayUtils;